import { store } from 'react-easy-state'

export const state = store({
  semaphore: 0,
  session: null,
  notifications: []
})

export default state
